import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HeroComputerError } from '@airwallex/hero-graphics';
import { ErrorState } from '@airwallex/page-state';
import useQuery from '@/hooks/useQuery';
import Terms from '@/components/Terms';
import { trace } from '@/utils/trace';

export enum ErrorType {
  EXPIRED = 'EXPIRED',
  DEFAULT = 'DEFAULT',
}

const ErrorTypeMap = {
  [ErrorType.EXPIRED]: {
    title: 'error.expired',
    description: 'error.expired.description',
  },
  [ErrorType.DEFAULT]: {
    title: 'error.default',
    description: 'error.default.description',
  },
};

const ErrorPage = () => {
  const { t } = useTranslation();
  const { code } = useQuery<{ code: ErrorType }>();
  const errorType = ErrorTypeMap[code] || ErrorTypeMap[ErrorType.DEFAULT];

  useEffect(() => {
    trace.mark('root_component_ready');
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100vh' }}>
      <ErrorState image={HeroComputerError} title={t(errorType.title)} body={t(errorType.description)} />
      <Terms />
    </div>
  );
};

export default ErrorPage;
